import Mousetrap from 'mousetrap'

/* @ngInject */
function modalStackService (StackService, $timeout) {
  const stack = StackService.createStack()

  const api = {
    _isAssetPreview
  }

  const service = {
    registerOpenedModal,
    closeLastOpenedModal,
    getLastModalOpened,
    getOpenedModals
  }
  return service

  function registerCloseCallback (closeFn) {
    Mousetrap.bind('esc', closeFn)
  }

  function deregisterCloseCallback () {
    Mousetrap.unbind('esc')
  }

  function closeLastOpenedModal () {
    stack.pop()
    const nextModalToClose = stack.peek()

    if (nextModalToClose) {
      registerCloseCallback(nextModalToClose.closeCallback)
    } else {
      deregisterCloseCallback()
    }
  }

  function registerOpenedModal (modal, closeCallback) {
    modal.closeCallback = closeCallback
    stack.push(modal)
    const modalEl = modal?.modalEl
    const isAssetPreview = api._isAssetPreview(modal.type)

    if (isAssetPreview || !modalEl) {
      registerCloseCallback(modal.closeCallback)
      return
    }

    $timeout(() => {
      const udsModalEl = modalEl.querySelector('uds-modal')
      const closableModal = !udsModalEl?.noClose

      if (closableModal) registerCloseCallback(modal.closeCallback)
    }, 100, true)
  }

  function getLastModalOpened () {
    return stack.peek()
  }

  function getOpenedModals () {
    return stack.getItems()
  }

  function _isAssetPreview (modalType) {
    const previewTypes = ['asset-preview', 'quick-preview']
    return previewTypes.includes(modalType)
  }
}

export { modalStackService }
